"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
exports.default = vue_1.defineComponent({
    props: {
        show: {
            type: Boolean,
            default: function () { return false; },
        },
        domClassName: {
            type: String,
            default: '',
        },
    },
    setup: function (props, ctx) {
        var data = vue_1.reactive({
            show: false,
            domClassName: '',
            startPosition: {
                left: '',
                top: '',
                cssText: '',
            },
        });
        vue_1.watchEffect(function () {
            data.show = props.show;
            data.domClassName = props.domClassName;
        });
        vue_1.onMounted(function () {
            var dragDom = document.getElementsByClassName(props.domClassName ? props.domClassName : 'drag-container')[0];
            if (!dragDom)
                return;
            var isDrag = false;
            vue_1.watch(function () { return data.show; }, function (newVal, oldVal) {
                var _a, _b, _c;
                data.show = newVal;
                if (newVal === oldVal)
                    return;
                if (data.show === true) {
                    dragDom.style.left = (_a = data.startPosition) === null || _a === void 0 ? void 0 : _a.left;
                    dragDom.style.top = (_b = data.startPosition) === null || _b === void 0 ? void 0 : _b.top;
                    dragDom.style.cssText = (_c = data.startPosition) === null || _c === void 0 ? void 0 : _c.cssText;
                }
            });
            var mouseDown = function (e) {
                isDrag = true;
                var X = e.clientX - dragDom.offsetLeft;
                var Y = e.clientY - dragDom.offsetTop;
                var move = function (e) {
                    e.preventDefault();
                    if (isDrag) {
                        dragDom.style.left = e.clientX - X + "px";
                        dragDom.style.top = e.clientY - Y + "px";
                    }
                };
                document.addEventListener('mousemove', throttle(move, 20), false);
                document.addEventListener('mouseup', function () {
                    isDrag = false;
                    document.removeEventListener('mousemove', move);
                });
            };
            dragDom.addEventListener('mousedown', mouseDown);
        });
        function throttle(fn, timer) {
            var initTime = 0;
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var nowTime = +new Date();
                if (nowTime - initTime > timer) {
                    initTime = nowTime;
                    fn.apply(ctx, args);
                }
            };
        }
        return __assign(__assign({}, vue_1.toRefs(data)), { throttle: throttle });
    },
});
